import { SettingsState } from '../types';
import { ActionType, SetSettings } from './settingsActions';
import { createReducer } from '../helper';

const initialState: SettingsState = {
  is_loading_libraries_enabled: null,
};

const setSettings = (
  state: SettingsState,
  action: SetSettings
): SettingsState => ({
  ...state,
  ...action.payload,
});

const handlers = {
  [ActionType.SET_SETTINGS]: setSettings,
};

export const settingsReducer = createReducer<SettingsState>(
  initialState,
  handlers
);
